import { Image, Link, Text, View } from "@react-pdf/renderer";
import logo from "Assets/images/logo.png";
import { globalStyles } from "config/pdfStyles";

const KhanReportLogoPdf = ({  }) => {
  return (
    <View style={{ gap: "3px" }}>
      <Image
        style={{ width: "20%", backgroundColor: "transparent", marginBottom: "5px" }}
        src={logo}
      />
      <Text style={globalStyles.fontBold}>
        Supporting development through life
      </Text>
      <View style={{ flexDirection: "row" }}>
        <Text>web:{" "}</Text>
        <Link src="https://khancommunicationservices.com">khancommunicationservices.com</Link>
      </View>
      <View style={{ flexDirection: "row" }}>
        <Text>Instagram:{" "}</Text>
        <Link src="https://www.instagram.com/khancommservices/">@khanCommServices</Link>
      </View>
    </View>
  )
}

export default KhanReportLogoPdf;